import {
  Icon,
  IconButton,
  Spacer,
  Split,
  SplitSection,
  SvgClose,
  SvgSparkle,
  Text,
} from '@loomhq/lens';
import React from 'react';

import arrowSvg from 'img/arrow.svg';

import styles from './styles.module.less';

const RecordReplyTooltip = ({ ownerName, onClick }) => {
  return (
    <div className={styles.recordReplyTooltipContainer}>
      <div className={styles.recordReplyArrow}>
        <img alt="" src={arrowSvg} />
      </div>
      <div className={styles.recordReplyTooltip}>
        <Split justifyContent="space-between">
          <SplitSection>
            <Spacer top=".2rem">
              <div className={styles.header}>
                <div className="flex items:center">
                  <Spacer right="0.375rem">
                    <Icon
                      color="blueDark"
                      size="0.875rem"
                      icon={<SvgSparkle />}
                    />
                  </Spacer>

                  <Text fontWeight="bold" size="small" inLine>
                    New
                  </Text>
                </div>
              </div>
            </Spacer>
          </SplitSection>

          <SplitSection>
            <IconButton
              size="small"
              icon={<SvgClose />}
              onClick={onClick}
              altText="Dismiss"
            />
          </SplitSection>
        </Split>

        <Spacer top="medium" bottom="small">
          <Text size="small" fontWeight="bold">
            Send a video message to {ownerName}
          </Text>
        </Spacer>

        <Text size="small">
          Try leaving feedback, providing context or leaving a quick note.
        </Text>
      </div>
    </div>
  );
};

export default RecordReplyTooltip;
